var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"status-page"},[_c('h1',[_vm._v("TimedRight")]),_c('font-awesome-icon',{staticClass:"error-icon",attrs:{"icon":"exclamation-triangle"}}),_c('h2',[_vm._v(" Sorry, the site is currently down for maintenance. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }